import { render } from "./stronaOgloszeniaBody.vue?vue&type=template&id=44a25910&scoped=true"
import script from "./stronaOgloszeniaBody.vue?vue&type=script&lang=js"
export * from "./stronaOgloszeniaBody.vue?vue&type=script&lang=js"

import "./stronaOgloszeniaBody.vue?vue&type=style&index=0&id=44a25910&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a25910"]])

export default __exports__